import { render, staticRenderFns } from "./MenuManager.vue?vue&type=template&id=0e7011bc&scoped=true&"
import script from "./MenuManager.vue?vue&type=script&lang=js&"
export * from "./MenuManager.vue?vue&type=script&lang=js&"
import style0 from "./MenuManager.vue?vue&type=style&index=0&id=0e7011bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7011bc",
  null
  
)

export default component.exports